<template>
    <ThePage>
        <template v-slot:title>
            <div class="d-flex flex-row">
                <div class="w-100">Торговые автоматы</div>
                <a target="_blank" :href="getKBLink('vms')" class="btn btn-outline-primary text-center"><i class="tlm-icon-question-circle" /></a>
            </div>
        </template>

        <div class="d-flex justify-content-between mb-4">
            <div class="d-none d-sm-flex flex-column flex-md-row">
                <select-date-range v-model="range" class="mr-md-4 mb-2 mb-md-0 flex-frow-1" />
                <date-range-picker v-model="range" :not-before="fourMonthsAgo" :not-after="new Date()" :shortcuts="false" :clearable="false" />
            </div>

            <div>
                <div class="d-none d-xl-inline-block mr-4">
                    <small>Выгрузить статистику:</small>
                    <button type="button" class="btn btn-outline-primary ml-3" @click.prevent="getFile('csv')">CSV</button>
                    <button type="button" class="btn btn-outline-primary ml-2" @click.prevent="getFile('xlsx')"><i class="tlm-icon-excel mr-2" /> Excel</button>
                </div>
                <router-link to="/vms/new" class="btn btn-primary text-nowrap"><i class="tlm-icon-plus mr-2" /> Создать автомат</router-link>
            </div>
        </div>

        <vm-list :vms="vms" :has-crt="hasCrt" :has-loading="hasLoading" :extended="true" :remove="true" :meta="meta" />

        <router-view />
    </ThePage>
</template>

<script>
import ThePage from '@/components/ThePage'
import VmList, { getFile } from '@/components/VmList'
import SelectDateRange from '@/components/SelectDateRange'
import DateRangePicker from '@/components/DateRangePicker'

import store from '@/store'
import DateCacheService, { oneWeekAgoRange, fourMonthsAgo } from '@/services/DateCacheService'
import KBLinksService from '@/services/KBLinksService'

function resolveDefaultRange() {
    return DateCacheService.getFormatted('dash', oneWeekAgoRange)
}

const beforeRoute = async (to, from, next) => {
    if (!to.query.since || !to.query.until) {
        return next({ name: to.name, query: resolveDefaultRange() })
    }

    // LITE-114
    // Некоторые пользователи (или сотрудники) редко пользуются Лайтом/ЛХ.
    // У них может в локалсторадже остаться очень старый интервал дат, бек на него ругнется своей валидацией.
    if (to.query.since && DateCacheService.isTooFar(to.query.since)) {
        DateCacheService.forget('dash')
        return next({ name: to.name })
    }

    await Promise.all([
        store.dispatch('vms/fetchAll', { ...to.query, vends: 1, loading: 1 })
    ])

    next()
}

export default {
    name: 'PageVms',

    components: {
        DateRangePicker,
        SelectDateRange,
        ThePage,
        VmList
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({ })
        }
    },

    computed: {
        vms() {
            return this.$store.state.vms.data || []
        },

        meta() {
            return this.$store.state.vms.meta || {}
        },

        companyUsage() {
            return this.$store.state.company.usage.data
        },

        hasCrt() {
            return this.$store.getters['company/hasCrt']
        },

        hasLoading() {
            return this.$store.getters['company/hasLoading']
        },

        noDataAtAll() {
            return this.vms.length === 0 && this.filter.search.length === 0
        },

        noDataWithFilter() {
            return this.vms.length === 0 && this.filter.search.length > 0
        },

        range: {
            set({ alias, ...range }) {
                alias
                    ? DateCacheService.setAlias('dash', alias)
                    : DateCacheService.set('dash', range)

                this.applyFilter({ ...range, page: 1 })
            },

            get() {
                return this.filter
            }
        },

        fourMonthsAgo
    },
    methods: {
        getFile,

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    },

    beforeRouteEnter: beforeRoute,
    beforeRouteUpdate: beforeRoute
}
</script>
